import React from 'react'
import './style.css'
import { createStore, withStore } from 'game_play/utils/store'
// import Field from 'championship/src/components/Fields/Field'
// import TabHeaders from './TabHeaders'
import TabHeader from './TabHeaders/TabHeader'
import { 
    Tournament, 
    currentTabAtom, 
    tabsAtom,
    messagesAtom,
    saveAtom,
    saveCallbackBoxAtom,
    cancelCallbackBoxAtom,
    pageAtom,
    tournamentIdAtom,
    // isAnnonceAtom, 
    // initialSchemaAtom,
    participantsAtom,
    requestsAtom,
    modelStore,
    getModelAtom,
    getModel,
    changeTabAction,
    leagueSlugAtom,
    getPlayerName
} from './model'
import TabFormat from './Tabs/format'
import tab_format_validation from './Tabs/format/validation'
import TabCommon from './Tabs/common'
import tab_common_validation from './Tabs/common/validation'
import TabMembers from './Tabs/members'
import tab_members_validation from './Tabs/members/validation'

import TestingBox from './TestingBox'

import { atom } from '@reatom/core'
import { checkTabValidation, installTabValidation } from './Tabs/utils'
import Skeleton from './Skeleton'
import Loader from '../Utils/Loader'
import { Dialog } from '../../classes/helpers/dialog'
import MessagesList from '../Utils/Messages/MessagesList'
import { AnimatePresence } from 'motion/react'
import MotionItem from '../Utils/Motions/MotionItem'
import SwipeMotion from '../Utils/Motions/SwipeMotion'
import { assignAtomsFromSchema, flushAtoms, updateAtomsFromData } from '../../classes/helpers/reatom'

// function assignAtomsFromDjangoFormSchema(schema, atoms, main_key = 'misc') {
//     for (const key in schema) {
//         const chain_key = `${main_key}.${key}`
//         const init_value = schema[key].current_value
//         atoms[chain_key] = {
//             schema: schema[key],
//             atom: atom(init_value)
//         }
//     }
//     return atoms;
// };


// function assignAtomsFromSchema(
//     schema, 
//     atoms, 
//     main_key = 'misc', 
//     init_value_callback,
//     additional_schema_key = null,
// ){
//     for (const key in schema) {
//         const chain_key = `${main_key}.${key}`
//         if(!Object.keys(atoms).includes(chain_key)){
//             const _atom = atom(init_value_callback(schema, key))
//             atoms[chain_key] = {
//                 schema: schema[key],
//                 atom: _atom,
//                 messages_atom: atom([])
//             }
//         }

//         /**
//          * handling the case when 2 diffenent schemas for 1 field are needed
//          */
//         if(additional_schema_key){
//             atoms[`${additional_schema_key}:${chain_key}`] = {
//                 ...atoms[chain_key],
//                 schema: schema[key],
//             }
//         }
//     }
//     return atoms;
// }


// function updateAtomsFromData(
//     ctx,
//     data, 
//     atoms, 
//     main_key = 'misc', 
//     value_callback,
// ){
//     for (const [key, schema] of Object.entries(data)) {
//         const chain_key = `${main_key}.${key}`
//         atoms[chain_key].atom(ctx, value_callback(schema))
//     }
//     return atoms;
// }


// function flushAtoms(ctx, atoms, main_key){
//     for(const [key, atom] of Object.entries(atoms)){
//         if (key.match(new RegExp(`^${main_key}`))){
//             atom.atom(ctx, null)
//         }
//     }
// }

class TournamentForm extends React.Component {
    constructor(props){
        super(props)
        const {Tournament} = this.props
        const ctx = Tournament.ctx
        this.ctx = ctx
        this.unsubscribes = []
        this.setApiRoutes(
            Tournament, 
            this.props.api_routes
        )
        // console.log(props)
        this.state = {
            tournament: null,
            is_inited: false,
            // is_annonce: ctx.get(getModelAtom('settings.annonce'))
            is_annonce: false,
            is_pending: false,
            is_testing: false,
            current_tab: null,
        }
        // this.initModelsFromProps()
        // console.log('modelStore', modelStore)
        window.dispatchEvent(new Event('resize'))
    }

    initModelsFromApi(response){
        const ctx = this.ctx
        const props = this.props
        const data = response.data

        tournamentIdAtom(this.ctx, data.tournament_id)
        leagueSlugAtom(this.ctx, data.league_slug)

        const dom_heading = document.getElementById('main_heading')

        pageAtom(this.ctx, {
            heading: (dom_heading ? dom_heading.innerHTML.trim() : '') ,
            title: document.title,
            url: window.location.href,
        })

        this.unsubscribes.push(this.ctx.subscribe(pageAtom, (page) => {
            // console.log('page changed', page)
            if (dom_heading) {
                dom_heading.innerHTML = page.heading
            }
            document.title = page.title

            if(window.location.pathname != page.url){
                window.history.pushState({
                        // "html":response.html,
                        "pageTitle": page.title
                    },
                    "", 
                    page.url
                );
            }
        }))

        assignAtomsFromSchema(
            response.page,
            modelStore, 
            'page',
            (schema, key) => schema[key].current_value
        )

        assignAtomsFromSchema(
            data.tournament_format,
            modelStore, 
            'tournament',
            (schema, key) => schema[key].current_value,
            'format'
        )

        assignAtomsFromSchema(
            data.tournament_annonce,
            modelStore, 
            'tournament',
            (schema, key) => schema[key].current_value,
            'annonce'
        )

        assignAtomsFromSchema(
            data.settings, 
            modelStore, 
            'settings',
            (schema, key) => schema[key].current_value
        )

        participantsAtom(ctx, data.participants)
        requestsAtom(ctx, data.requests)
        saveCallbackBoxAtom(ctx, {callback: this.trySave.bind(this)})
        cancelCallbackBoxAtom(ctx, {callback: this.cancel.bind(this)})

        this.setState({
            is_inited: true,
            is_annonce: ctx.get(getModelAtom('settings.annonce'))
        })       

        this.unsubscribes.push(ctx.subscribe(getModelAtom('settings.annonce'), (value) => {
            this.setState({
                is_annonce: value
            })
        }))

        this.initCurrentTab()

        this.initTabs()
        this.routes = response.routes
        window.dispatchEvent(new Event('resize'))
    }

    updateStateFromApi(response){
        const ctx = this.ctx
        const data = response.data

        updateAtomsFromData(
            this.ctx, 
            data.tournament_annonce,
            modelStore, 
            'tournament',
            (item) => item.current_value
        )

        updateAtomsFromData(
            this.ctx, 
            data.tournament_format,
            modelStore, 
            'tournament',
            (item) => item.current_value
        )

        updateAtomsFromData(
            this.ctx, 
            data.settings, 
            modelStore, 
            'settings',
            (item) => item.current_value
        )

        tournamentIdAtom(this.ctx, data.tournament_id)
        leagueSlugAtom(this.ctx, data.league_slug)

        const page = response.page
        
        if (Object.keys(page).length > 0){
            pageAtom(this.ctx, {
                ...this.ctx.get(pageAtom),
                ...page,
            })
        }

        participantsAtom(ctx, data.participants)
        
        const {Tournament} = this.props
        this.setApiRoutes(Tournament, response.routes.tournament)
        this.routes = response.routes
    }

    processMessages(messages = []){
        messagesAtom(this.ctx, [...messages])
        for(const message of messages){
            // if(message.id === 'main'){
            //     this.status = message.level
            // }
            const field_model = getModel(message.id)
            if(field_model){
                const messages = this.ctx.get(field_model.messages_atom)
                field_model.messages_atom(this.ctx, [...messages, [message]])
            }
        }
    }

    initTabs(){
        const ctx = this.ctx
        this.current_tab_ref = null    
        this.unsubscribes.push(ctx.subscribe(currentTabAtom, (key) => {
            // if(this.current_tab_body){
            //     this.current_tab_body.classList.remove('-active')
            // }
            // const tab = ctx.get(tabsAtom)?.[key]
            // if(tab){
            //     tab.ref_body.current.classList.add('-active')
            //     this.current_tab_body = tab.ref_body.current
            // }
            this.setState({
                current_tab: key
            })
        }))
        const tabs = {
            common: {
                label: 'Общая информация',
                validation_schema: tab_common_validation,
            },
            format:{
                label: 'Формат турнира',
                // validation: tab_format_validation,
                validation_schema: tab_format_validation,
            },
            members:{
                label: 'Участники',
                validation_schema: tab_members_validation,
                validation_invoke_atom: participantsAtom,
                validation_callback: (ctx, schema) => {
                    const participants = ctx.get(participantsAtom)
                    return participants.length > 0
                }
            },
        }
        for(const [key, tab] of Object.entries(tabs)){
            tab.key = key
            tab.ref_body = React.createRef()
            tab.done = false
            // if(tab?.validation){
            //     tab.validation
            //     installTabValidation(this.ctx, )
            // }
        }
        tabsAtom(ctx, tabs)
        assignAtomsFromSchema(
            tabs, 
            modelStore, 
            'tabs',
            (schema, key) => {
                return {is_done: false}
            }
        )

        let prev_tab_atom = {is_done: true}
        for(const [key, tab] of Object.entries(tabs)){
            const model_key = `tabs.${key}`
            const model = getModel(model_key)
            model.schema.validation = installTabValidation(
                this.ctx,
                model_key,
                tab.validation_schema
            )
            model.schema.prev_tab_atom = prev_tab_atom
            prev_tab_atom = model.atom
        }
        
        // getModelAtom('tabs.common')
    }

    initCurrentTab(){
        // this.unsubscribes.push(this.ctx.subscribe(currentTabAtom, (value) => {
        //     // console.log(value)
        //     this.setState({
        //         current_tab: value
        //     })
        // }))
        setTimeout(()=>{
            currentTabAtom(this.ctx, 'common')
            
            const target_tab_match = window.location.hash.match(/\#tab\=([a-zA-Z0-9_\-]+)/)
            let target_tab_key;
            if(target_tab_match && target_tab_match.length > 0 ){
                target_tab_key = target_tab_match[1]
            }
            if(target_tab_key){
                getModelAtom('settings.annonce')(this.ctx, false)
                let current_tab = this.ctx.get(currentTabAtom)
                console.log(current_tab)
                while(current_tab !== target_tab_key){
                    const tab_model = getModel(`tabs.${current_tab}`)
                    // model.atom
                    const tab_state = this.ctx.get(tab_model.atom)
                    if(tab_state.is_done){
                        changeTabAction(this.ctx, 1)
                        
                        current_tab = this.ctx.get(currentTabAtom)
                    }else{
                        checkTabValidation(this.ctx, tab_model)
                        break;
                    }
                }
            }else{
                currentTabAtom(this.ctx, 'common')
            }

            // currentTabAtom(this.ctx, 'format')
            // currentTabAtom(this.ctx, 'members')
        }, 100)
    }

    componentDidMount(){
        // currentTabAtom(this.ctx, 'common')
        // currentTabAtom(this.ctx, 'format')
        // currentTabAtom(this.ctx, 'members')
        // setTimeout(() => {
        //     this.initLoad()
        // }, 500)
        this.initLoad()
    }
    
    initLoad(){
        const {Tournament} = this.props    
        Tournament.fetch()
            .then((response) => {
                // console.log('GOT INIT', response)
                this.initModelsFromApi(response)
                this.tryFetch()
            })
            .catch((error) => {
                console.log('ERROR', error)
            }) 
    }

    tryFetch(){
        const {Tournament} = this.props    
        this.setPending(true)
        Tournament.fetch()
            .then((response) => {
                // console.log('GOT', response)
                setTimeout(() => {
                    this.updateStateFromApi(response)
                    this.setPending(false)
                }, 200)
            })
            .catch((error) => {
                console.log('ERROR', error)
                this.setPending(false)
            }) 
    }
    
    setApiRoutes(Model, api){
        Model.get_url = api.get
        Model.post_url = api.post
    }

    trySave(){

        if(this.state.is_pending) { 
            return
        }

        const data = {
            tournament: {},
            settings: {},
            participants: [],
        }
        for(const [key, model] of Object.entries(modelStore)){
            if(key.includes('tournament.')){
                data.tournament[key.replace('tournament.', '')] = this.ctx.get(model.atom)
            }
        }
        for(const [key, model] of Object.entries(modelStore)){
            if(key.includes('settings.')){
                data.settings[key.replace('settings.', '')] = this.ctx.get(model.atom)
            }
        }
        // console.log('participantsAtom', this.ctx.get(participantsAtom))
        data.participants = this.ctx.get(participantsAtom).map((participant)=>{
            return { 
                id: Math.max(participant?.id, 0), //(participant?.id > 0 ? participant.id : 0),
                order: participant?.order ?? 0,
                seed:  participant?.seed,
                group:  participant?.group,
                request_id: participant?.request_id,
                player: participant?.player?.id,
                player_1: participant?.player_1?.id,
                player_2: participant?.player_2?.id,
                player_3: participant?.player_3?.id,
            }
        })
        data.requests = this.ctx.get(requestsAtom)
        // const headers = {
        //     'X-CSRFToken': this.props.csrf_token
        // }
        const {Tournament} = this.props

        this.setPending(true)
        // console.log('SENDING_DATA', data)
        Tournament
            .save(data)
            .then((response) => {
                console.log(response)

                if(response.status.error){
                    Dialog.toast({
                        type: 'error',
                        title: 'Что-то пошло не так'
                    })
                }else{
                    Dialog.toast({
                        type: 'success',
                        title: 'Турнир сохранён'
                    })
                    this.updateStateFromApi(response)
                    if(!this.state.is_testing){
                        setTimeout(()=>{
                            this.cancel()
                        }, 1000)
                    }
                }
                this.processMessages(response.messages)
                this.setPending(false)
            })
            .catch(error => {
                console.log(error)
                Dialog.toast({
                    type: 'error',
                    title: 'Что-то пошло не так'
                })
                this.setPending(false)
            })
    }

    cancel(){
        console.log('cancel')
        window.location.href = this.routes.league.edit
    }

    setPending(bool){
        this.setState({
            is_pending: bool,
        })
    }

    componentWillUnmount(){
        for(const _unsubscribe of this.unsubscribes){
            _unsubscribe()
        }
    }
    // componentDidMount(){
    //      messagesAtom(this.ctx, [])
    // }

    render(){
        const is_testing = this.state.is_testing;

        const tabs = this.ctx.get(tabsAtom)

        // const errors = this.ctx.get(messagesAtom)
        const errors = []

        if(! this.state.is_inited){
            return (
                <div>
                    {/* <button onClick={this.initLoad.bind(this)}>
                        test init
                    </button>
                    <button onClick={this.tryFetch.bind(this)}>
                        test fetch
                    </button>
                    <button onClick={this.trySave.bind(this)}>
                        test save
                    </button> */}
                    <Skeleton />
                </div>
            )
        }

        return (
            <AnimatePresence
                // initial={false}
                >
            <div className="reactive-form">

                <div className="reactive-form__loader">
                    {/* <Loader 
                        type="4"
                        active={this.state.is_pending}
                        /> */}
                    {this.state.is_pending && (
                        <div className="loader-ui">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    )}
                </div>
                {is_testing && (
                    <TestingBox />
                )}
                {is_testing && (
                    <div style={{display:'flex'}}>
                        <div style={{flexGrow:1}}></div>
                        <button onClick={() => {window.location.href="/accounts/organizer/superklub/tournaments/create-reactive"}}>
                            open new create
                        </button>
                        <button onClick={this.tryFetch.bind(this)}>
                            test fetch
                        </button>
                        <button onClick={this.trySave.bind(this)}>
                            test save
                        </button>
                        <div style={{display: 'flex', flexDirection: 'column'}}>
                            {Object.entries(this.routes).map(([set_key, _set]) => (
                                Object.entries(_set).map(([route_key, url]) => (
                                    <a href={url}>
                                        {set_key}.{route_key}
                                    </a>
                                ))
                            ))}
                        </div>
                    </div>
                )}

                <div className="reactive-form-tab-headers">
                    <TabHeader 
                        // tab={tabs.common}
                        model="tabs.common"
                        // atom={tabs.common.atom}
                        // is_done={tabs.common.done}
                        // atom={getModelAtom('tabs.common')}
                        // separator={!this.state.is_annonce}
                        />
                    {/* {!this.state.is_annonce && (
                        <div />
                    )} */}
                    {!this.state.is_annonce && (
                        <TabHeader 
                            // tab={tabs.format}
                            model="tabs.format"
                            // is_done={tabs.common.done}
                            // atom={getModelAtom('tabs.format')}
                            separator={true}
                            />
                    )}
                    {!this.state.is_annonce && (
                        <TabHeader 
                            tab={tabs.members}
                            model="tabs.members"
                            // atom={getModelAtom('tabs.members')}
                            separator={true}
                            />
                    )}
                </div>
                
                {this.state.current_tab == 'common' && (
                    <SwipeMotion
                        key='tab_common'
                        >
                        <TabCommon
                            trans_ref={tabs.common.ref_body}
                            model="tabs.common"
                            />

                    </SwipeMotion>    
                )}

                {this.state.current_tab == 'format' && (
                    <SwipeMotion
                        key='tab_format'
                        >
                        <TabFormat 
                            trans_ref={tabs.format.ref_body}
                            model="tabs.format"
                            />

                    </SwipeMotion>    
                )}

                {this.state.current_tab == 'members' && (
                    <SwipeMotion
                        key='tab_members'
                        >
                        <TabMembers
                            trans_ref={tabs.members.ref_body}
                            model="tabs.members"
                            />
                    </SwipeMotion> 
                )}

                {/* <TabCommon
                    trans_ref={tabs.common.ref_body}
                    model="tabs.common"
                    />
                {!this.state.is_annonce && (
                    <TabFormat 
                        trans_ref={tabs.format.ref_body}
                        model="tabs.format"
                        />
                )}

                {!this.state.is_annonce && (
                    <TabMembers
                        trans_ref={tabs.members.ref_body}
                        model="tabs.members"
                        />
                )} */}

                <MessagesList 
                    atom={messagesAtom}
                    />

                <div className="errors">
                    {errors.map((error) => (
                        <div>
                            {error.id}<span> </span>
                            {error.text}
                        </div>
                    ))}
                </div>
            </div>
            </AnimatePresence>
        )
    }
}

const TournamentFormWithStore = createStore(withStore(TournamentForm), {
  Tournament
}, {
//   tournaments: window.INIT_DATA || []
    tournament: {
        // get: '/accounts/organizer/api/tournament/superklub/',
        // post: '/accounts/organizer/api/tournament/superklub/',
        // post: '/accounts/organizer/superklub/tournaments/create'
    }
})
// const TournamentFormWithStore = TournamentForm
export default TournamentFormWithStore